import React, { memo } from 'react';

const CertifiedShop = () => {

    return <div className="smdWrapperTag" />;
}

export default memo(CertifiedShop);